(function(){
    'use strict';

    angular
    .module('appback')
    .controller('NominasController', NominasController)
 
    NominasController.$inject = ["$scope","$http","$timeout","$uibModal", "$log", "$document","$sce",'Upload', 'NominasService'];
              
    function NominasController($scope,$http,$timeout,$uibModal, $log, $document,$sce,Upload, NominasService)
    {                         
        var vm = this;
        vm.nominas = [];
        vm.nominasSubidas = [];
        vm.contador = 0;

        vm.setFiles = function(files){
            $scope.$apply(function(){
              vm.nominas = files;
            });
          };

        vm.uploadNominas = function(){
            console.log("subiendo nominas", vm.nominas);
            if(vm.nominas.length > 0){
                Upload.upload({
                    url: '/backend/nominas/uploadmultiplenominas',
                    arrayKey: '',
                    data: {
                        'files[]': vm.nominas
                    }
                }).then(function (resp) {
                    console.log("Subida múltiple exitosa", resp);
                    vm.nominasSubidas = resp.data;
                    vm.nominas = [];
                    vm.saveNominas();
                }, function (error) {
                    console.error("Error al subir múltiples archivos", error);
                });
            }
        }

        vm.saveNominas = function(){
            console.log("ejecutando saveNominas");
            vm.contador = 0;
            function saveNextNomina() {
                if (vm.contador < vm.nominasSubidas.length) {
                    let nomina = vm.nominasSubidas[vm.contador];
                    if (nomina.saved) {
                        console.log("guardando la nomina", nomina);
                        NominasService.saveNomina(nomina)
                        .then(function (resp) {
                            console.log("nomina guardada", resp);
                            if(resp.data.code > 0){
                                nomina.done = true;
                            } else {
                                nomina.saved = false;
                            }
                            vm.contador++;
                            saveNextNomina(); // Call the function recursively
                        }, function (error) {
                            console.error("Error al subir múltiples archivos", error);
                        });
                       
                    } else {
                        vm.contador++;
                        saveNextNomina(); // Skip to the next if not saved
                    }
                }
            }

            saveNextNomina(); // Start the recursive process
        }
            
    }
  
})();